/**
 * Адрес страницы-объяснения отдельным модулем: его берёт панель раздела, которая работает
 * в браузере. Через общий модуль виджета в браузерный пакет уехали бы серверные запросы страницы.
 */
export const requestLandingPath = '/fulfillment/request'

/** Куда ведёт кнопка со страницы: сам мастер заявки. */
export const requestWizardPath = '/fulfillment/request/new'
